<ng-container *ngIf="theme?.trackingMethods?.impressionTag">
    <ng-container *ngIf="theme?.trackingMethods?.impressionTag?.pixel?.url">
        <img [src]="theme?.trackingMethods?.impressionTag?.pixel?.url" alt="Advertisement" attributionsrc BORDER="0" HEIGHT="1" WIDTH="1" [style.display]="'none'">
    </ng-container>
    <ng-container *ngIf="theme?.trackingMethods?.impressionTag?.iframe?.url">
        <iframe [src]="theme?.trackingMethods?.impressionTag?.iframe?.url" WIDTH=1 HEIGHT=1 MARGINWIDTH=0 MARGINHEIGHT=0 HSPACE=0 VSPACE=0 FRAMEBORDER=0 SCROLLING=no BORDERCOLOR='#000000'></iframe>
    </ng-container>
    <ng-container *ngIf="theme?.trackingMethods?.impressionTag?.script?.url">
        <script language='JavaScript1.1' [src]="theme?.trackingMethods?.impressionTag?.script?.url" attributionsrc></script>
    </ng-container>
    <ng-container *ngIf="theme?.trackingMethods?.impressionTag?.noscript?.url">
        <noscript>
            <img [src]="theme?.trackingMethods?.impressionTag?.noscript?.url" alt="Advertisement" attributionsrc BORDER="0" HEIGHT="1" WIDTH="1" [style.display]="'none'">
        </noscript>
    </ng-container>
</ng-container>